import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, type Theme } from "../lib/api";
import { useAuth } from "../lib/auth";
import { unlockAudio } from "../lib/audio";
import { LOBBY_ROUND_COUNTS, type LobbyRoundCount } from "@themix/shared";

export default function MultiHub() {
  const nav = useNavigate();
  const { user } = useAuth();
  const [nickname, setNickname] = useState("");
  const [themes, setThemes] = useState<Theme[]>([]);
  const [selected, setSelected] = useState<number[]>([]);
  const [mix, setMix] = useState(true);
  const [count, setCount] = useState<LobbyRoundCount>(10);
  const [seconds, setSeconds] = useState(30);
  const [err, setErr] = useState("");

  useEffect(() => {
    void api<Theme[]>("/api/themes").then(setThemes);
  }, []);

  useEffect(() => {
    if (user?.nickname && !nickname) setNickname(user.nickname);
  }, [user, nickname]);

  async function create() {
    setErr("");
    await unlockAudio();
    try {
      const res = await api<{ code: string; playerId: string; reconnectToken: string }>("/api/lobbies", {
        method: "POST",
        body: JSON.stringify({
          nickname,
          settings: { themeIds: mix ? [] : selected, mixRandom: mix, roundCount: count, roundSeconds: seconds },
        }),
      });
      const blob = JSON.stringify(res);
      sessionStorage.setItem("themix_player", blob);
      localStorage.setItem("themix_player", blob);
      nav(`/j/${res.code}`);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Erreur");
    }
  }

  return (
    <div className="grid gap-5 pt-4">
      <h1 className="font-display text-4xl">Nouveau salon</h1>
      <input
        className="rounded-2xl bg-cream text-ink px-4 py-3"
        placeholder="Ton pseudo"
        value={nickname}
        onChange={(e) => setNickname(e.target.value)}
        maxLength={24}
      />
      <label className="flex gap-2 items-center">
        <input type="checkbox" checked={mix} onChange={(e) => setMix(e.target.checked)} />
        Mélange aléatoire
      </label>
      {!mix && (
        <div className="flex flex-wrap gap-2">
          {themes.map((t) => {
            const on = selected.includes(t.id);
            return (
              <button
                key={t.id}
                type="button"
                onClick={() => setSelected((s) => (on ? s.filter((x) => x !== t.id) : [...s, t.id]))}
                className={`rounded-full px-3 py-1 text-sm border ${on ? "bg-gold text-ink" : "border-cream/30"}`}
              >
                {t.name}
              </button>
            );
          })}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {LOBBY_ROUND_COUNTS.map((n) => (
          <button key={n} type="button" onClick={() => setCount(n)} className={`rounded-2xl px-4 py-3 ${count === n ? "bg-mint text-ink" : "bg-ink-2"}`}>
            {n}
          </button>
        ))}
      </div>
      <label>
        Durée {seconds}s
        <input type="range" min={15} max={60} value={seconds} onChange={(e) => setSeconds(Number(e.target.value))} />
      </label>
      {err && <p className="text-pink">{err}</p>}
      <button type="button" disabled={nickname.trim().length < 2} onClick={() => void create()} className="rounded-3xl bg-pink py-4 font-bold text-xl">
        Créer le salon
      </button>
    </div>
  );
}
